<template>
  <input
    :placeholder="placeholder"
    :value="value"
    @input="$emit('input', $event.target.value)"
  />
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: ''
    };
  }
};
</script>

<style lang="scss" scoped>
input {
  width: 100%;
  text-align: center;
  border: 2px solid black;
  border-radius: 5px;
  padding: 5px 0;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
